module.exports = __webpack_public_path__ + "static/media/pen.a5033c10.svg";